/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { BoundingBox } from './BoundingBox';
import { BoundingBoxFromJSON, BoundingBoxFromJSONTyped, BoundingBoxToJSON, } from './BoundingBox';
import type { PredictionSingletonBase } from './PredictionSingletonBase';
import { PredictionSingletonBaseFromJSON, PredictionSingletonBaseFromJSONTyped, PredictionSingletonBaseToJSON, } from './PredictionSingletonBase';
import type { Probabilities } from './Probabilities';
import { ProbabilitiesFromJSON, ProbabilitiesFromJSONTyped, ProbabilitiesToJSON, } from './Probabilities';
/*
causes circular dependendies
// .concat(PredictionSingletonBaseValidator)

*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface PredictionSingletonKeypointDetection
 *
 */
// create custom validators for the regexes
export interface PredictionSingletonKeypointDetection extends PredictionSingletonBase {
    /**
     * [x1, y2, s1, ..., xk, yk, sk] as outlined by https://docs.lightly.ai/docs/prediction-format#keypoint-detection
     * #type Array<number>
     * #memberof PredictionSingletonKeypointDetection
        
        
         */
    keypoints: Array<number>;
    /**
     *
     * #type BoundingBox
     * #memberof PredictionSingletonKeypointDetection
        
        
         */
    bbox?: BoundingBox;
    /**
     *
     * #type Probabilities
     * #memberof PredictionSingletonKeypointDetection
        
        
         */
    probabilities?: Probabilities;
}
/**
 * Check if a given object implements the PredictionSingletonKeypointDetection interface.
 */
export function instanceOfPredictionSingletonKeypointDetection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "keypoints" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { BoundingBoxValidator, BoundingBoxStringifyShape, BoundingBoxStringifyShapeProperties, } from './BoundingBox';
import { PredictionSingletonBaseValidator, PredictionSingletonBaseStringifyShape, PredictionSingletonBaseStringifyShapeProperties, } from './PredictionSingletonBase';
import { ProbabilitiesValidator, ProbabilitiesStringifyShape, ProbabilitiesStringifyShapeProperties, } from './Probabilities';
export const PredictionSingletonKeypointDetectionTypiaAssertEquals = (input: any) => {
    return ((input: any): PredictionSingletonKeypointDetection => {
        const __is = (input: any, _exceptionable: boolean = true): input is PredictionSingletonKeypointDetection => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => Array.isArray(input.keypoints) && input.keypoints.every((elem: any, _index1: number) => "number" === typeof elem) && (undefined === input.bbox || "object" === typeof input.bbox && null !== input.bbox && $io1(input.bbox, true && _exceptionable)) && (undefined === input.probabilities || "object" === typeof input.probabilities && null !== input.probabilities && $io2(input.probabilities, true && _exceptionable)) && "string" === typeof input.type && ("string" === typeof input.taskName && $is_custom("pattern_PredictionSingletonBase_taskName", "string", "", input.taskName)) && (undefined === input.cropDatasetId || "string" === typeof input.cropDatasetId && $is_custom("pattern_PredictionSingletonBase_cropDatasetId", "string", "", input.cropDatasetId)) && (undefined === input.cropSampleId || "string" === typeof input.cropSampleId && $is_custom("pattern_PredictionSingletonBase_cropSampleId", "string", "", input.cropSampleId)) && ("number" === typeof input.categoryId && 0 <= input.categoryId) && ("number" === typeof input.score && 0 <= input.score && 1 >= input.score) && (5 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["keypoints", "bbox", "probabilities", "type", "taskName", "cropDatasetId", "cropSampleId", "categoryId", "score"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "number" === typeof value;
                return false;
            });
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "number" === typeof value;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is PredictionSingletonKeypointDetection => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ((Array.isArray(input.keypoints) || $guard(_exceptionable, {
                    path: _path + ".keypoints",
                    expected: "Array<number>",
                    value: input.keypoints
                })) && input.keypoints.every((elem: any, _index1: number) => "number" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".keypoints[" + _index1 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".keypoints",
                    expected: "Array<number>",
                    value: input.keypoints
                })) && (undefined === input.bbox || ("object" === typeof input.bbox && null !== input.bbox || $guard(_exceptionable, {
                    path: _path + ".bbox",
                    expected: "(BoundingBox | undefined)",
                    value: input.bbox
                })) && $ao1(input.bbox, _path + ".bbox", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".bbox",
                    expected: "(BoundingBox | undefined)",
                    value: input.bbox
                })) && (undefined === input.probabilities || ("object" === typeof input.probabilities && null !== input.probabilities || $guard(_exceptionable, {
                    path: _path + ".probabilities",
                    expected: "(Probabilities | undefined)",
                    value: input.probabilities
                })) && $ao2(input.probabilities, _path + ".probabilities", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".probabilities",
                    expected: "(Probabilities | undefined)",
                    value: input.probabilities
                })) && ("string" === typeof input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "string",
                    value: input.type
                })) && ("string" === typeof input.taskName && ($is_custom("pattern_PredictionSingletonBase_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_PredictionSingletonBase_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string",
                    value: input.taskName
                })) && (undefined === input.cropDatasetId || "string" === typeof input.cropDatasetId && ($is_custom("pattern_PredictionSingletonBase_cropDatasetId", "string", "", input.cropDatasetId) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetId",
                    expected: "string (@pattern_PredictionSingletonBase_cropDatasetId)",
                    value: input.cropDatasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetId",
                    expected: "(string | undefined)",
                    value: input.cropDatasetId
                })) && (undefined === input.cropSampleId || "string" === typeof input.cropSampleId && ($is_custom("pattern_PredictionSingletonBase_cropSampleId", "string", "", input.cropSampleId) || $guard(_exceptionable, {
                    path: _path + ".cropSampleId",
                    expected: "string (@pattern_PredictionSingletonBase_cropSampleId)",
                    value: input.cropSampleId
                })) || $guard(_exceptionable, {
                    path: _path + ".cropSampleId",
                    expected: "(string | undefined)",
                    value: input.cropSampleId
                })) && ("number" === typeof input.categoryId && (0 <= input.categoryId || $guard(_exceptionable, {
                    path: _path + ".categoryId",
                    expected: "number (@minimum 0)",
                    value: input.categoryId
                })) || $guard(_exceptionable, {
                    path: _path + ".categoryId",
                    expected: "number",
                    value: input.categoryId
                })) && ("number" === typeof input.score && (0 <= input.score || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "number (@minimum 0)",
                    value: input.score
                })) && (1 >= input.score || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "number (@maximum 1)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "number",
                    value: input.score
                })) && (5 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["keypoints", "bbox", "probabilities", "type", "taskName", "cropDatasetId", "cropSampleId", "categoryId", "score"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "number" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "number",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "number" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "number",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "PredictionSingletonKeypointDetection",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "PredictionSingletonKeypointDetection",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const PredictionSingletonKeypointDetectionTypiaAssertStringify = (input: PredictionSingletonKeypointDetection): string => {
    return ((input: any): string => { const assert = (input: any): PredictionSingletonKeypointDetection => {
        const __is = (input: any): input is PredictionSingletonKeypointDetection => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => Array.isArray(input.keypoints) && input.keypoints.every((elem: any) => "number" === typeof elem && !Number.isNaN(elem)) && (undefined === input.bbox || "object" === typeof input.bbox && null !== input.bbox && $io1(input.bbox)) && (undefined === input.probabilities || "object" === typeof input.probabilities && null !== input.probabilities && $io2(input.probabilities)) && "string" === typeof input.type && ("string" === typeof input.taskName && $is_custom("pattern_PredictionSingletonBase_taskName", "string", "", input.taskName)) && (undefined === input.cropDatasetId || "string" === typeof input.cropDatasetId && $is_custom("pattern_PredictionSingletonBase_cropDatasetId", "string", "", input.cropDatasetId)) && (undefined === input.cropSampleId || "string" === typeof input.cropSampleId && $is_custom("pattern_PredictionSingletonBase_cropSampleId", "string", "", input.cropSampleId)) && ("number" === typeof input.categoryId && !Number.isNaN(input.categoryId) && 0 <= input.categoryId) && ("number" === typeof input.score && 0 <= input.score && 1 >= input.score);
            const $io1 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "number" === typeof value && !Number.isNaN(value);
                return true;
            });
            const $io2 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "number" === typeof value && !Number.isNaN(value);
                return true;
            });
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is PredictionSingletonKeypointDetection => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ((Array.isArray(input.keypoints) || $guard(_exceptionable, {
                    path: _path + ".keypoints",
                    expected: "Array<number>",
                    value: input.keypoints
                })) && input.keypoints.every((elem: any, _index1: number) => "number" === typeof elem && !Number.isNaN(elem) || $guard(_exceptionable, {
                    path: _path + ".keypoints[" + _index1 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".keypoints",
                    expected: "Array<number>",
                    value: input.keypoints
                })) && (undefined === input.bbox || ("object" === typeof input.bbox && null !== input.bbox || $guard(_exceptionable, {
                    path: _path + ".bbox",
                    expected: "(BoundingBox | undefined)",
                    value: input.bbox
                })) && $ao1(input.bbox, _path + ".bbox", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".bbox",
                    expected: "(BoundingBox | undefined)",
                    value: input.bbox
                })) && (undefined === input.probabilities || ("object" === typeof input.probabilities && null !== input.probabilities || $guard(_exceptionable, {
                    path: _path + ".probabilities",
                    expected: "(Probabilities | undefined)",
                    value: input.probabilities
                })) && $ao2(input.probabilities, _path + ".probabilities", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".probabilities",
                    expected: "(Probabilities | undefined)",
                    value: input.probabilities
                })) && ("string" === typeof input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "string",
                    value: input.type
                })) && ("string" === typeof input.taskName && ($is_custom("pattern_PredictionSingletonBase_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_PredictionSingletonBase_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string",
                    value: input.taskName
                })) && (undefined === input.cropDatasetId || "string" === typeof input.cropDatasetId && ($is_custom("pattern_PredictionSingletonBase_cropDatasetId", "string", "", input.cropDatasetId) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetId",
                    expected: "string (@pattern_PredictionSingletonBase_cropDatasetId)",
                    value: input.cropDatasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetId",
                    expected: "(string | undefined)",
                    value: input.cropDatasetId
                })) && (undefined === input.cropSampleId || "string" === typeof input.cropSampleId && ($is_custom("pattern_PredictionSingletonBase_cropSampleId", "string", "", input.cropSampleId) || $guard(_exceptionable, {
                    path: _path + ".cropSampleId",
                    expected: "string (@pattern_PredictionSingletonBase_cropSampleId)",
                    value: input.cropSampleId
                })) || $guard(_exceptionable, {
                    path: _path + ".cropSampleId",
                    expected: "(string | undefined)",
                    value: input.cropSampleId
                })) && ("number" === typeof input.categoryId && !Number.isNaN(input.categoryId) && (0 <= input.categoryId || $guard(_exceptionable, {
                    path: _path + ".categoryId",
                    expected: "number (@minimum 0)",
                    value: input.categoryId
                })) || $guard(_exceptionable, {
                    path: _path + ".categoryId",
                    expected: "number",
                    value: input.categoryId
                })) && ("number" === typeof input.score && (0 <= input.score || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "number (@minimum 0)",
                    value: input.score
                })) && (1 >= input.score || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "number (@maximum 1)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "number",
                    value: input.score
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "number" === typeof value && !Number.isNaN(value) || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "number",
                            value: value
                        });
                    return true;
                }));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "number" === typeof value && !Number.isNaN(value) || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "number",
                            value: value
                        });
                    return true;
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "PredictionSingletonKeypointDetection",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "PredictionSingletonKeypointDetection",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: PredictionSingletonKeypointDetection): string => {
        const $io1 = (input: any): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
            if (["length"].some((prop: any) => key === prop))
                return true;
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                return "number" === typeof value;
            return true;
        });
        const $io2 = (input: any): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
            if (["length"].some((prop: any) => key === prop))
                return true;
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                return "number" === typeof value;
            return true;
        });
        const $string = (typia.createAssertStringify as any).string;
        const $join = (typia.createAssertStringify as any).join;
        const $tail = (typia.createAssertStringify as any).tail;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.bbox ? "" : `"bbox":${undefined !== input.bbox ? $so1(input.bbox) : undefined},`}${undefined === input.probabilities ? "" : `"probabilities":${undefined !== input.probabilities ? $so2(input.probabilities) : undefined},`}${undefined === input.cropDatasetId ? "" : `"cropDatasetId":${undefined !== input.cropDatasetId ? $string(input.cropDatasetId) : undefined},`}${undefined === input.cropSampleId ? "" : `"cropSampleId":${undefined !== input.cropSampleId ? $string(input.cropSampleId) : undefined},`}"keypoints":${`[${input.keypoints.map((elem: any) => elem).join(",")}]`},"type":${$string(input.type)},"taskName":${$string(input.taskName)},"categoryId":${input.categoryId},"score":${input.score}}`;
        const $so1 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${value}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        const $so2 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${value}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const PredictionSingletonKeypointDetectionValidatorShape = {
    'keypoints': yup.array().of(yup.number().min(0)).min(3).defined(),
    'bbox': BoundingBoxValidator.optional().default(undefined),
    'probabilities': ProbabilitiesValidator.optional().default(undefined),
};
export const PredictionSingletonKeypointDetectionValidator = yup.object().shape(PredictionSingletonKeypointDetectionValidatorShape).concat(PredictionSingletonBaseValidator);
export const PredictionSingletonKeypointDetectionStringifyShapeProperties: ObjectSchema['properties'] = {
    'keypoints': {
        type: 'array',
        'minItems': 3,
        items: {
            type: 'number'
        } as unknown as fastJSON.Schema,
    } as unknown as fastJSON.ArraySchema,
    'bbox': BoundingBoxStringifyShape,
    'probabilities': ProbabilitiesStringifyShape,
};
export const PredictionSingletonKeypointDetectionStringifyShape: ObjectSchema = {
    title: 'PredictionSingletonKeypointDetection Stringifier',
    type: 'object',
    properties: {
        ...PredictionSingletonBaseStringifyShapeProperties,
        ...PredictionSingletonKeypointDetectionStringifyShapeProperties
    },
    required: [
        ...(PredictionSingletonBaseStringifyShape.required ? PredictionSingletonBaseStringifyShape.required : []),
        'keypoints',
    ],
};
export const PredictionSingletonKeypointDetectionStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(PredictionSingletonKeypointDetectionStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const PredictionSingletonKeypointDetectionStringify: (data: PredictionSingletonKeypointDetection) => string = PredictionSingletonKeypointDetectionStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function PredictionSingletonKeypointDetectionFromJSON(json: any): PredictionSingletonKeypointDetection {
    return PredictionSingletonKeypointDetectionFromJSONTyped(json, false);
}
export function PredictionSingletonKeypointDetectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PredictionSingletonKeypointDetection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
    if (!ignoreDiscriminator) {
    }
*/
    return {
        ...PredictionSingletonBaseFromJSONTyped(json, ignoreDiscriminator),
        'keypoints': json['keypoints'],
        'bbox': !exists(json, 'bbox') ? undefined : BoundingBoxFromJSON(json['bbox']),
        'probabilities': !exists(json, 'probabilities') ? undefined : ProbabilitiesFromJSON(json['probabilities']),
    };
}
export function PredictionSingletonKeypointDetectionToJSON(value?: PredictionSingletonKeypointDetection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...PredictionSingletonBaseToJSON(value),
        'keypoints': value.keypoints,
        'bbox': BoundingBoxToJSON(value.bbox),
        'probabilities': ProbabilitiesToJSON(value.probabilities),
    };
}
